import { useEffect } from "react";
import { useLocation } from "wouter";

/**
 * ScrollToTop — fires window.scrollTo(0, 0) whenever the route changes.
 * Place this inside <Router> so it has access to the wouter location.
 */
export default function ScrollToTop() {
  const [location] = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location]);

  return null;
}
